import { render, staticRenderFns } from "./MyCompanies.vue?vue&type=template&id=56321094&scoped=true"
import script from "./MyCompanies.vue?vue&type=script&lang=js"
export * from "./MyCompanies.vue?vue&type=script&lang=js"
import style0 from "./MyCompanies.vue?vue&type=style&index=0&id=56321094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56321094",
  null
  
)

export default component.exports